import { ref } from "vue";

/**
 * Reusable exit-guard for IQ controlled suggestion overlays (bounded, ephemeral, task-scoped).
 * When unreviewed suggestions remain, intercepts close and shows the exit confirmation dialog.
 */
export function useIQSuggestOverlayExitConfirm({
  enabled,
  isControlledSuggestOverlay,
  remainingSuggestions,
  resetSession,
  performClose,
}) {
  const showExitConfirm = ref(false);

  function requestClose() {
    if (
      !enabled.value ||
      !isControlledSuggestOverlay.value ||
      remainingSuggestions.value <= 0
    ) {
      performClose();
      return;
    }
    showExitConfirm.value = true;
  }

  function keepReviewing() {
    showExitConfirm.value = false;
  }

  function confirmExit() {
    showExitConfirm.value = false;
    if (typeof resetSession === "function") {
      resetSession();
    }
    performClose();
  }

  return {
    showExitConfirm,
    requestClose,
    keepReviewing,
    confirmExit,
  };
}
